import React from 'react';
import { Form } from 'react-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Text, Textarea, Checkbox, Select } from 'components/FormElements/';
import AutomaticMessageService from 'services/AutomaticMessageService';
import { toggleLoading, toggleAlertError } from 'stores/actions/';
import { required } from 'constants/InputErrors';

const hours = [
  { id: '1', name: '1' },
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' },
  { id: '5', name: '5' },
  { id: '6', name: '6' },
  { id: '7', name: '7' },
  { id: '8', name: '8' },
  { id: '9', name: '9' },
  { id: '10', name: '10' },
  { id: '11', name: '11' },
  { id: '12', name: '12' },
  { id: '13', name: '13' },
  { id: '14', name: '14' },
  { id: '15', name: '15' },
  { id: '16', name: '16' },
  { id: '17', name: '17' },
  { id: '18', name: '18' },
  { id: '19', name: '19' },
  { id: '20', name: '20' },
  { id: '21', name: '21' },
  { id: '22', name: '22' },
  { id: '23', name: '23' },
  { id: '24', name: '24' },
];

class AutomaticMessageEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      categories: []
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    if( this.entityId ) {
      this.props.toggleLoading( true );

      AutomaticMessageService.getAutomaticMessage( this.entityId )
        .then( ( response ) => {
          this.props.toggleLoading( false );
          if( !response.errors ) this.setState( {
            data: {
              ...response.data,
              fromHour: response.data.fromHour ? { id: response.data.fromHour, name: response.data.fromHour } : null,
              toHour: response.data.toHour ? { id: response.data.toHour, name: response.data.toHour } : null
            }
          } )
        } )
    }
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );

    if( data.category === 'all' ) data.category = '';
    data.category = _.isObject( data.category ) ? data.category.id : data.category;
    if( data.weekDays ) {
      data.weekDays = _.isString( data.weekDays ) ? data.weekDays.split( ',' ) : data.weekDays;
      data.fromHour = _.isObject( data.fromHour ) ? Number( data.fromHour.id ) : Number( data.fromHour );
      data.toHour = _.isObject( data.toHour ) ? Number( data.toHour.id ) : Number( data.toHour );
    }

    const promise = this.entityId ? AutomaticMessageService.updateAutomaticMessage( this.entityId, data ) :
      AutomaticMessageService.saveAutomaticMessage( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( '/configurations/automatic-messages' )
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{this.entityId ? <Translate id="edit"/> : <Translate id="new"/>} <Translate
          id="automaticMessage"/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                name: required( values.name ),
                description: required( values.description ),
                config: required( values.config ),
                type: required( values.type ),
                fromHour: values.weekDays ? required( values.fromHour ) : null,
                toHour: values.weekDays ? required( values.toHour ) : null,
              }
            }}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="name"/></label>
                    <Text field="name" className="form-control"/>
                  </FormGroup>

                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="config"/></label>
                    <Select field="config" className="form-control" placeholder=""
                            options={[{ id: 'created_channel', name: 'Create Channel' }]}/>
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="type"/></label>
                    <Select field="type" className="form-control" placeholder=""
                            options={[
                              { id: 'facebook', name: 'Facebook' },
                              { id: 'twitter', name: 'Twitter' },
                              { id: 'email', name: 'Email' }
                            ]}/>
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup containerClass="col-md-4">
                    <label><Translate id="weekDays"/></label>
                    <Select field="weekDays" className="form-control" placeholder="" multi
                            options={[
                              { id: 'sunday', name: 'Sunday' },
                              { id: 'monday', name: 'Monday' },
                              { id: 'tuesday', name: 'Tuesday' },
                              { id: 'wednesday', name: 'Wednesday' },
                              { id: 'thursday', name: 'Thursday' },
                              { id: 'friday', name: 'Friday' },
                              { id: 'saturday', name: 'Saturday' }
                            ]}
                            suffixIcon={<i className="fa fa-calendar"/>}/>
                  </FormGroup>
                  <FormGroup containerClass="col-md-2">
                    <label><Translate id="fromHour"/></label>
                    <Select field="fromHour" className="form-control" placeholder=""
                            options={hours}
                            suffixIcon={<i className="fa fa-clock-o"/>}/>
                  </FormGroup>
                  <FormGroup containerClass="col-md-2">
                    <label><Translate id="toHour"/></label>
                    <Select field="toHour" className="form-control" placeholder=""
                            options={hours}
                            suffixIcon={<i className="fa fa-clock-o"/>}/>
                  </FormGroup>
                </div>

                <FormGroup>
                  <label><Translate id="description"/></label>
                  <Textarea field="description" className="form-control" rows={5}/>
                </FormGroup>

                <FormGroup containerClass="col-md-2 pl-0">
                  <Checkbox field="active" label={<Translate id="active"/>}/>
                </FormGroup>

                <div className="text-right mt-4">
                  <Link to={`/configurations/automatic-messages`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AutomaticMessageEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/automatic-messages/edit/index.js